export default {
  xs: '1px',
  s: '2px',
  m: '4px',
  pill: '100vh',
  round: '50%',
};
